import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import Auth from '@/pages/Auth';
import Contact from '@/pages/Contact';
import FAQ from '@/pages/FAQ';
import StudioDashboard from '@/pages/StudioDashboard';
import CoordinatorDashboard from '@/pages/CoordinatorDashboard';
import StudioDirectory from '@/pages/StudioDirectory';
import StudioProfile from '@/pages/StudioProfile';
import Subscription from '@/pages/Subscription';
import CreateStudioProfile from '@/pages/CreateStudioProfile';
import BoothConfiguration from '@/pages/BoothConfiguration';
import CalendarManagement from '@/pages/CalendarManagement';
import { Toaster } from 'sonner';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import HoldingPage from './pages/HoldingPage';

// Check if holding page should be shown
const SHOW_HOLDING_PAGE = process.env.REACT_APP_SHOW_HOLDING_PAGE === 'true';

function AppRoutes() {
  const { user, loading, refreshUser } = useAuth();

  const ProtectedRoute = ({ children, role }) => {
    if (loading) return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
    if (!user) return <Navigate to="/auth" replace />;
    if (role && user.role !== role) return <Navigate to="/" replace />;
    return children;
  };

  return (
    <>
      {SHOW_HOLDING_PAGE ? (
        <HoldingPage />
      ) : (
        <Routes>
          <Route path="/" element={<LandingPage user={user} />} />
          <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <Auth />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              {user?.role === 'studio' ? <StudioDashboard user={user} refreshUser={refreshUser} /> : <CoordinatorDashboard user={user} />}
            </ProtectedRoute>
          } />
          <Route path="/directory" element={<ProtectedRoute><StudioDirectory user={user} /></ProtectedRoute>} />
          <Route path="/studio/:id" element={<StudioProfile user={user} />} />
          <Route path="/subscription" element={<ProtectedRoute role="studio"><Subscription user={user} refreshUser={refreshUser} /></ProtectedRoute>} />
          <Route path="/booth-config" element={<ProtectedRoute role="studio"><BoothConfiguration user={user} /></ProtectedRoute>} />
          <Route path="/create-profile" element={<ProtectedRoute role="studio"><CreateStudioProfile user={user} /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute role="studio"><CalendarManagement user={user} /></ProtectedRoute>} />
        </Routes>
      )}
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;